import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IEntregas } from "../../global/types";
import { custoFreelancers, custoKmRodado, custoPorPedido, dieselGasto, minutosExtras, minutosPorKm, minutosPorPedido, porcCusto, qtdDiarias, salarioDia, totalDiaAjudantes, totalExtraAjudantes, totalGasto, valorHrExtra } from "../../utils/calculos";
import { currencyFormatter } from "../../utils/currencyFormatter";
import { compareInHoursAndMin, convertDateSqlToDate, convertDateToBr, minutesToHours } from "../../utils/dateProvider";
import { maskNumber } from "../../utils/masks";

import "./style.css"

type IProps = {
  closeModal: () => void
  entrega: IEntregas
}

export function DetalheEntregaModal({ closeModal, entrega }: IProps) {
  return (
    <div id="mdDetalhesEntrega" className="modal">
      <div className="title">
        <p>Detalhes da Entrega</p>
        <FontAwesomeIcon icon={faTimes} style={{ cursor: "pointer" }} onClick={closeModal} />
      </div>

      <div className="body">
        <div className="dvDetails">

          <div className="dvInfo" style={{ width: "49%" }}>
            <b>Roteiro:</b>
            <p>{maskNumber(`${entrega.roteiro}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "49%" }}>
            <b>Data:</b>
            <p>{convertDateToBr(convertDateSqlToDate(`${entrega.data}`))}</p>
          </div>

          <div className="dvInfo" style={{ width: "49%" }}>
            <b>Veículo:</b>
            <p>{entrega.veiculo.nome}</p>
          </div>

          <div className="dvInfo" style={{ width: "49%" }}>
            <b>Motorista:</b>
            <p>{entrega.motorista.nome}</p>
          </div>

          {entrega.ajudante && (
            <div className="dvInfo" style={{ width: "100%" }}>
              <b>Ajudante:</b>
              <p>{entrega.ajudante.nome}</p>
            </div>
          )}

          <div className="dvInfo" style={{ width: "100%" }}>
            <b>Ajudante(s):</b>
            <p>
              {entrega.freelancers && entrega.freelancers.filter(e => e.funcao === 0).map((rs, i) => (
                i > 0 ? ` / ${rs.pessoa.nome}` : rs.pessoa.nome
              ))}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "100%" }}>
            <b>Freelancers:</b>
            <p>
              {entrega.freelancers && entrega.freelancers.filter(e => e.funcao === 1).map((rs, i) => (
                i > 0 ? ` / ${rs.pessoa.nome}` : rs.pessoa.nome
              ))}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "100%" }}>
            <b>Cidade:</b>
            <p>
              {entrega.cidades && entrega.cidades.map((rs, i) => (
                i > 0 ? `/${rs.cidade.nome}` : rs.cidade.nome
              ))}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Carga:</b>
            <p>{currencyFormatter(parseFloat(`${entrega.valor_carga}`))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Pedido:</b>
            <p>{maskNumber(`${entrega.pedidos}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Entrada:</b>
            <p>{`${entrega.entrada}`.slice(0, 5)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Saída:</b>
            <p>{`${entrega.saida}`.slice(0, 5)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Hr Trab:</b>
            <p>{compareInHoursAndMin(`${entrega.entrada}`, `${entrega.saida}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Km Inicial:</b>
            <p>{maskNumber(`${entrega.km_inicial}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Km Final:</b>
            <p>{maskNumber(`${entrega.km_final}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Km Rodados:</b>
            <p>{maskNumber(`${parseInt(`${entrega.km_final}`) - parseInt(`${entrega.km_inicial}`)}`)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Temp. Ped.:</b>
            <p>{minutosPorPedido(entrega)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Temp. Km:</b>
            <p>{minutosPorKm(entrega)}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Diesel:</b>
            <p>{currencyFormatter(dieselGasto(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Diárias:</b>
            <p>{currencyFormatter(parseFloat(`${entrega.diarias}`) * qtdDiarias(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Motorista:</b>
            <p>{currencyFormatter(salarioDia(entrega, "motorista"))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Ajudante:</b>
            <p>
              {currencyFormatter(
                salarioDia(entrega, "ajudante") +
                totalDiaAjudantes(entrega)
              )}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Hr Extra Motor:</b>
            <p>{minutesToHours(minutosExtras(entrega, "motorista"))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Extra Motor:</b>
            <p>{currencyFormatter(valorHrExtra(entrega, minutosExtras(entrega, "motorista"), "motorista"))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Extra Ajud:</b>
            <p>
              {currencyFormatter(
                valorHrExtra(entrega, minutosExtras(entrega, "ajudante"), "ajudante") +
                totalExtraAjudantes(entrega)
              )}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Extra Total:</b>
            <p>
              {currencyFormatter(
                valorHrExtra(entrega, minutosExtras(entrega, "motorista"), "motorista") +
                valorHrExtra(entrega, minutosExtras(entrega, "ajudante"), "ajudante") +
                totalExtraAjudantes(entrega)
              )}
            </p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Freelancers:</b>
            <p>{currencyFormatter(custoFreelancers(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Pedágio:</b>
            <p>{currencyFormatter(parseFloat(`${entrega.valor_pedagio}`))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Balsa:</b>
            <p>{currencyFormatter(parseFloat(`${entrega.valor_pedagio}`))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>$ Diversos:</b>
            <p>{currencyFormatter(parseFloat(`${entrega.diversos}`))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Gasto Total:</b>
            <p>{currencyFormatter(totalGasto(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Custo Km Rod:</b>
            <p>{currencyFormatter(custoKmRodado(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Custo Entrega:</b>
            <p>{currencyFormatter(custoPorPedido(entrega))}</p>
          </div>

          <div className="dvInfo" style={{ width: "23.65%" }}>
            <b>Porc. Custo:</b>
            <p>{porcCusto(entrega).toFixed(2)}%</p>
          </div>

        </div>
      </div>

    </div>
  )
}